/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type AgentPolicyGrantIDForm = {
  /**
   * First-class agent identifier
   */
  agentId: string;
  /**
   * Direct policy grant identifier
   */
  grantId: string;
};

/** @internal */
export type AgentPolicyGrantIDForm$Outbound = {
  agent_id: string;
  grant_id: string;
};

/** @internal */
export const AgentPolicyGrantIDForm$outboundSchema: z.ZodMiniType<
  AgentPolicyGrantIDForm$Outbound,
  AgentPolicyGrantIDForm
> = z.pipe(
  z.object({
    agentId: z.string(),
    grantId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      agentId: "agent_id",
      grantId: "grant_id",
    });
  }),
);

export function agentPolicyGrantIDFormToJSON(
  agentPolicyGrantIDForm: AgentPolicyGrantIDForm,
): string {
  return JSON.stringify(
    AgentPolicyGrantIDForm$outboundSchema.parse(agentPolicyGrantIDForm),
  );
}
